import { render, staticRenderFns } from "./VerDetalleListaDistribucionModal.vue?vue&type=template&id=08210d0c&"
import script from "./VerDetalleListaDistribucionModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleListaDistribucionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08210d0c', component.options)
    } else {
      api.reload('08210d0c', component.options)
    }
    module.hot.accept("./VerDetalleListaDistribucionModal.vue?vue&type=template&id=08210d0c&", function () {
      api.rerender('08210d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ListaDistribucion/VerDetalleListaDistribucionModal.vue"
export default component.exports